import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DefaultTheme } from 'themes/interfaces/default-theme.interfaces';
import clsx from 'clsx';

export interface SectionProps {
  className?: string
}

type Props = React.PropsWithChildren<SectionProps>;

const makeClasses = makeStyles<DefaultTheme>(() => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
}));

export const Section: React.FC<Props> = (props: Props) => {
  const { className, children } = props;
  const classes = makeClasses();
  return (
    <section className={clsx(classes.wrapper, className)}>
      {children}
    </section>
  )
}